import React from 'react';
import {IoClose} from 'react-icons/io5';
import {Player} from '../../types';

const DETAILS: [keyof Player, string][] = [
    ['nickname', 'Spitzname'],
    ['birthday', 'Geburtstag'],
    ['height', 'Größe'],
    ['jump', 'Sprunghöhe'],
    ['motto', 'Motto'],
    ['food', 'Lieblingsessen'],
    ['drink', 'Lieblingsgetränk'],
];

interface PlayerCardProps {
    player: Player;
    isOpen: boolean;
    onToggle: () => void;
    /** lets the team grid animate and scroll to the card */
    cardRef?: (element: HTMLElement | null) => void;
}

/** Photo, name and position; players with details open into a full-width card with a detail panel. */
const PlayerCard = ({player, isOpen, onToggle, cardRef}: PlayerCardProps) => {
    const details = DETAILS.filter(([field]) => player[field]);
    const showNumber = !player.trainer && String(player.number ?? '').trim() !== '';
    const initials = `${player.firstname?.[0] ?? ''}${player.lastname?.[0] ?? ''}`;

    const face = (
        <>
            <span className="player-card-photo">
                {player.picture_url
                    ? <img src={player.picture_url} alt={`${player.firstname} ${player.lastname}`} loading="lazy"/>
                    : <span className="player-card-initials" aria-hidden="true">{initials}</span>}
                {showNumber && <span className="player-card-number">{player.number}</span>}
            </span>
            <span className="player-card-info">
                <span className="player-card-name">{player.firstname} <strong>{player.lastname}</strong></span>
                {player.position && <span className="player-card-position">{player.position}</span>}
            </span>
        </>
    );

    return (
        <article ref={cardRef} className={`player-card${isOpen ? ' is-open' : ''}`}>
            {details.length ? (
                <button type="button" className="player-card-face" aria-expanded={isOpen} onClick={onToggle}>
                    {face}
                </button>
            ) : (
                <div className="player-card-face">{face}</div>
            )}
            {isOpen && (
                <div className="player-card-panel">
                    <div className="player-card-panel-head">
                        {showNumber && <span className="player-card-panel-number">{player.number}</span>}
                        <div>
                            <h3 className="player-card-panel-name">{player.firstname} <strong>{player.lastname}</strong></h3>
                            {player.position && <p className="player-card-position">{player.position}</p>}
                        </div>
                        <button type="button" className="player-card-close" onClick={onToggle} aria-label="Schließen">
                            <IoClose aria-hidden="true"/>
                        </button>
                    </div>
                    <dl className="player-card-details">
                        {details.map(([field, label]) => (
                            <React.Fragment key={field}>
                                <dt>{label}</dt>
                                <dd>{String(player[field])}</dd>
                            </React.Fragment>
                        ))}
                    </dl>
                </div>
            )}
        </article>
    );
};

export default PlayerCard;
